import { render, staticRenderFns } from "./SequencesUpload.vue?vue&type=template&id=59c3a43c&"
import script from "./SequencesUpload.vue?vue&type=script&lang=js&"
export * from "./SequencesUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports